// v47 — which My Radar pipeline the open page works in.
// URL `?pl=` wins; otherwise the last one this browser opened. Pages
// outside /my-radar (Creator Intel grids, full profiles) always mean
// Live pipeline unless a call passes its own header.
const KEY = "kr.radar.pipeline";
export const LIVE = "live";
export const PL_HEADER = "X-Radar-Pipeline";

export function currentPipeline() {
  if (typeof window === "undefined" || !window.location.pathname.startsWith("/my-radar")) return LIVE;
  const q = new URLSearchParams(window.location.search).get("pl");
  if (q) {
    try { localStorage.setItem(KEY, q); } catch (_) { /* private mode */ }
    return q;
  }
  try { return localStorage.getItem(KEY) || LIVE; } catch (_) { return LIVE; }
}

export function setCurrentPipeline(pid) {
  try { localStorage.setItem(KEY, pid || LIVE); } catch (_) { /* private mode */ }
}

// "/my-radar/creator/x" → "/my-radar/creator/x?pl=<pid>"
export function withPl(path, pid) {
  const p = pid || currentPipeline();
  return `${path}${path.includes("?") ? "&" : "?"}pl=${encodeURIComponent(p)}`;
}

export const plHeaders = (pid) => ({ headers: { [PL_HEADER]: pid || LIVE } });
